import CityAirportTemplate from '../../components/templates/CityAirportTemplate';

export default function TaxiVianenEindhovenAirportPage() {
  return (
    <CityAirportTemplate
      city="Vianen"
      airport="eindhoven"
      airportName="Eindhoven Airport"
      price={90.00}
      distance="78 km"
      duration="60-65 minuten"
    />
  );
}
